/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortform_Text_PlaceholderInputs */

const en_shortform_text_placeholder = /** @type {(inputs: Shortform_Text_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shortform Text (e.g. hw)`)
};

const fr_shortform_text_placeholder = /** @type {(inputs: Shortform_Text_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texte abrégé (ex. hw)`)
};

const de_shortform_text_placeholder = /** @type {(inputs: Shortform_Text_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kurzform-Text (z. B. hw)`)
};

const it_shortform_text_placeholder = /** @type {(inputs: Shortform_Text_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Testo abbreviato (ad esempio hw)`)
};

const ru_shortform_text_placeholder = /** @type {(inputs: Shortform_Text_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Краткий текст (например, домашнее задание)`)
};

const es_shortform_text_placeholder = /** @type {(inputs: Shortform_Text_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texto abreviado (p. ej., tarea)`)
};

const zh_cn2_shortform_text_placeholder = /** @type {(inputs: Shortform_Text_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`简体文本（例如：作业）`)
};

const ja_shortform_text_placeholder = /** @type {(inputs: Shortform_Text_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`短縮テキスト（例：hw）`)
};

const hi_shortform_text_placeholder = /** @type {(inputs: Shortform_Text_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संक्षिप्त पाठ (उदाहरण: गृहकार्य)`)
};

const pt_pt2_shortform_text_placeholder = /** @type {(inputs: Shortform_Text_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texto abreviado (ex.: hw)`)
};

/**
* | output |
* | --- |
* | "Shortform Text (e.g. hw)" |
*
* @param {Shortform_Text_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortform_text_placeholder = /** @type {((inputs?: Shortform_Text_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortform_Text_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortform_text_placeholder(inputs)
	if (locale === "de") return de_shortform_text_placeholder(inputs)
	if (locale === "it") return it_shortform_text_placeholder(inputs)
	if (locale === "ru") return ru_shortform_text_placeholder(inputs)
	if (locale === "es") return es_shortform_text_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_shortform_text_placeholder(inputs)
	if (locale === "ja") return ja_shortform_text_placeholder(inputs)
	if (locale === "hi") return hi_shortform_text_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_shortform_text_placeholder(inputs)
	return en_shortform_text_placeholder(inputs)
});